import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_nav_label",
  "use": "icon-icon_nav_label-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-icon_nav_label\">\n<path id=\"icon-icon_nav_label_矩形-copy-69\" class=\"st0\" d=\"M13,1c0.6,0,1,0.4,1,1v11.8c0,0.6-0.4,1-1,1c-0.2,0-0.4-0.1-0.6-0.2l-4.2-3.3l-4.5,3.4\n\tc-0.4,0.3-1.1,0.2-1.4-0.2C2.1,14.2,2,14,2,13.8V2c0-0.6,0.4-1,1-1H13z M13,2H3v11.8l4.5-3.4c0.3-0.2,0.8-0.3,1.1-0.1l0.1,0.1\n\tl4.2,3.3V2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol